import Axios from "axios";
import { SETTINGS } from "../../../properties/ApiProps";

export const ProfessionalTitleRepository = {
  saveProfessionalTitleData: (vacId, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/professionalTitles`,
      method: "POST",
      data: data,
    });
  },
  getProfessionalTitleData: (vacId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/professionalTitles`,
      method: "GET",
    });
  },
  getAllTypes: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}professionalTitleType`,
      method: "GET",
      params: { gradingSchemaId: gradingSchemaId },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  getAllAreas: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}professionalTitleArea`,
      method: "GET",
      params: { gradingSchemaId: gradingSchemaId },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  updatePoints: (id, points) => {
    return Axios({
      url: `${SETTINGS.API_URL}professionalTitle/${id}/points`,
      params: { points: points },
      method: "PUT",
    });
  },

  unlockPoints: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}professionalTitle/${id}/unlockPoints`,
      method: "PUT",
    });
  },

  setComment: (id, comment) => {
    return Axios({
      url: `${SETTINGS.API_URL}professionalTitle/${id}/comment`,
      params: { comment: comment },
      method: "PUT",
    });
  },
};
